'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('licenses', {
    url: '/licenses',
    template: '<licenses></licenses>',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/licenses/licenses.routes.js